import {APP_INITIALIZER, NgModule} from '@angular/core';
import { CommonModule } from '@angular/common';
import { CallbackComponent} from './components/callback/callback.component';
import { LogoutComponent} from './components/logout/logout.component';
import { MatProgressSpinnerModule as MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { LoaderComponent } from './components/loader/loader.component';
import { AuthService} from './services/auth.service';
import { UserService} from './services/user.service';
import { MotdService } from './services/motd.service';
import { OciComponent } from './components/oci/oci.component.ts';

@NgModule({
  declarations: [
    CallbackComponent,
    LogoutComponent,
    LoaderComponent,
    OciComponent
  ],
  imports: [
    CommonModule,
    MatProgressSpinnerModule
  ],
  providers: [
    AuthService,
    UserService,
    MotdService,
    {
      provide: APP_INITIALIZER,
      useFactory:  (authService: AuthService) => () => authService.loadUser(),
      deps: [AuthService],
      multi: true,
    },
  ],
  exports: [
    CallbackComponent,
    LogoutComponent,
    OciComponent
  ]
})
export class AuthClientModule { }
